import React from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import QuestionableCalls from "../components/QuestionableCalls";
import Loading from "../components/Loading";
import PitchCriteria from "../components/filters/PitchCriteria";
import ShiftModelCriteria from "../components/filters/ShiftModelCriteria";
import ApplyButton from "../components/filters/ApplyButton";
import FilterSidebar from "../components/layout/FilterSidebar";
import rem from "../utils/rem";

const Wrapper = styled.div`
  display: flex;
  height: calc(100vh - ${rem(60)});
`;

class StrikeZoneContainer extends React.Component {
  componentDidMount() {
    this.props.rootStore.questionableCallsStore.fetchData();
  }

  render() {
    const {
      rootStore: { questionableCallsStore: store }
    } = this.props;

    return (
      <Wrapper>
        <FilterSidebar>
          <PitchCriteria store={store} multiVenue />
          <ShiftModelCriteria store={store} />
          <ApplyButton clickHandler={store.fetchData} />
        </FilterSidebar>
        {store.isLoading ? (
          <Loading />
        ) : (
          <QuestionableCalls data={store.data} isLoading={store.isLoading} />
        )}
      </Wrapper>
    );
  }
}

export default inject("rootStore")(observer(StrikeZoneContainer));



// WEBPACK FOOTER //
// ./src/containers/QuestionableCallsContainer.js